import type { ReactNode } from "react"

interface AuthWrapperProps {
  children: ReactNode
  maxWidth?: string
  className?: string
  backgroundClassName?: string
  backgroundImage?: string
  backgroundPosition?: string
  style?: React.CSSProperties
}

/**
 * AuthWrapper - Reusable layout component for authentication and onboarding pages
 *
 * Encapsulates the common layout structure:
 * - Outer container with background color
 * - Centered flex layout
 * - Card with consistent styling
 */
export function AuthWrapper({ children, maxWidth = "640px", className = "" }: AuthWrapperProps) {
  return (
    <div className="flex items-center justify-center min-h-screen px-4 z-10 relative">
      <div
        className={`w-full p-7 shadow-lg dark:bg-white/5 backdrop-blur-lg border dark:border-white/30 rounded-tr-[30px] rounded-bl-[30px] ${className}`}
        style={{ maxWidth }}
      >
        {children}
      </div>
    </div>
  )
}
